import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../providers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { IconButton, Tooltip } from "@mui/material";

export default function AuthIconButton() {
    const {user, logout} = useAuth();
    const navigate = useNavigate();


    const handleClick = async () => {
        if (user) {
            await logout();
            navigate("/");
        } else {
            navigate("/login");
        }
    };
    return <Tooltip title={user ? "Logout" : "Login"}>
        <IconButton onClick={handleClick} color="inherit">
            {user ? <LogoutIcon style={{color: "rebeccapurple"}} /> : <LoginIcon style={{color: "rebeccapurple"}}/>}
        </IconButton>
    </Tooltip>
}
